<form [formGroup]="projectForm" (submit)="save()" fxLayout="column" class="app-form">

  <mat-form-field appearance="outline">
    <mat-label i18n>DESIGN NAME</mat-label>
    <input matInput formControlName="name" i18n-placeholder placeholder="Give a name to the design...">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label i18n>DESCRIPTION</mat-label>
    <input matInput formControlName="description" i18n-placeholder placeholder="Inform the description...">
  </mat-form-field>

  <ng-container *ngIf="!editionMode || uploadError">

    <mat-form-field appearance="outline" class="app-block">
      <mat-label i18n>FILE</mat-label>
      <ngx-mat-file-input #file formControlName="file" accept=".zip">
      </ngx-mat-file-input>
      <button mat-icon-button matSuffix *ngIf="!file.empty; else attachment" (click)="file.clear($event)">
        <mat-icon>clear</mat-icon>
      </button>
      <ng-template #attachment>
        <button type="button" mat-icon-button matSuffix>
          <mat-icon>insert_drive_file</mat-icon>
        </button>
      </ng-template>
      <mat-hint i18n>Only ZIP</mat-hint>
    </mat-form-field>
    <mat-error *ngIf="file.empty && uploadError" i18n>Error on processing last upload file</mat-error>
    <p *ngIf="progress">
      <mat-progress-bar mode="determinate" color="accent" [value]="progress"></mat-progress-bar>
    </p>

  </ng-container>

  <ng-container *ngIf="!editionMode">

    <app-location-search [locationTypes]="locationTypes" (locationSelected)="locationFeature = $event.option.value">
    </app-location-search>

  </ng-container>

  <mat-action-row>
    <button mat-raised-button [disabled]="!projectForm.valid || (!editionMode && !locationFeature)" i18n>SAVE</button>
  </mat-action-row>

</form>

<app-card-error [error]="error"></app-card-error>
